<template>
  <form @submit.prevent="submit" class="form" id="call-request-form">
    <Input
      class="name"
      placeholder="Имя"
      v-model.trim="name"
      :error="nameError"
      @blur="$v.name.$touch()"
    />

    <Input
      v-model="phone"
      type="text"
      placeholder="Телефон"
      :mask="{
        mask: '+375 (99) 999-99-99',
        placeholder: '_',
        showMaskOnHover: false,
      }"
      :error="phoneError"
      :invalid="$v.phone.$error || phoneMaskError"
      @blur="$v.phone.$touch()"
      @invalid-mask="phoneMaskError = $event"
    />

    <Button @click.native="submit" class="submit" variant="base">
      Заказать звонок
    </Button>

    <div class="agree">
      <Checkbox v-model="accepted" :highlight-key="checkboxErrorKey">
        <span @click.stop
          >Нажимая “Заказать звонок” я соглашаюсь на обработку моих персональных
          данных в соответствии с
          <router-link
            exact
            :to="privacyPolicyPath"
            class="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Политикой конфиденциальности
          </router-link>
        </span>
      </Checkbox>
    </div>
  </form>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import Input from "./Input.vue";
import Button from "./Button.vue";
import Checkbox from "./Checkbox.vue";
import { thanksPath } from "@/router/thanks";
import { privacyPolicyPath } from "@/router/privacyPolicy";
import api from "@/application";

export default {
  name: "CallRequestForm",

  components: {
    Input,
    Button,
    Checkbox,
  },

  data() {
    return {
      name: "",
      phone: "",
      accepted: false,
      thanksPath,
      privacyPolicyPath,
      phoneMaskError: false,
      isRequesting: false,
      checkboxErrorKey: 0,
    };
  },

  validations: {
    name: { required, maxLength: maxLength(50) },
    phone: { required },
  },

  computed: {
    nameError() {
      if (!this.$v.name.$dirty) return "";
      if (!this.$v.name.required) return "Поле обязательно для заполнения";
      return "";
    },

    phoneError() {
      if (!this.$v.phone.$dirty) return "";
      if (!this.$v.phone.required) return "Поле обязательно для заполнения";
      if (this.phoneMaskError) return "Некорректный номер телефона";
      return "";
    },
    isDisabled() {
      return (
        this.$v.$invalid ||
        this.phoneMaskError ||
        !this.accepted ||
        this.isRequesting
      );
    },
  },

  methods: {
    async submit() {
      this.$v.$touch();
      this.phoneMaskError = this.phoneMaskError || false;

      if (!this.accepted) {
        this.checkboxErrorKey++;
      }

      if (this.$v.$invalid || this.phoneMaskError || !this.accepted) {
        return;
      }

      this.isRequesting = true;

      try {
        await api.mail.sendMessageOnOrderedCall({
          contactName: this.name,
          phone: this.phone,
          callType: "CONSULTATION",
        });

        localStorage.setItem("phone", this.phone);
        localStorage.setItem("name", this.name);

        this.name = "";
        this.phone = "";
        this.phoneMaskError = false;

        this.$router.push(thanksPath);
        this.$toast.success("Спасибо! Мы свяжемся с Вами в ближайшее время!");
      } catch (e) {
        this.$toast.error(e.message || "Ошибка при отправке формы");
      } finally {
        this.isRequesting = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.form {
  margin: 0 auto;
  max-width: 1248px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, max-content);
  grid-template-areas:
    "name phone submit"
    "agree agree agree";
  gap: 24px;
  @media (max-width: 1439px) {
    max-width: 468px;
    align-items: center;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 1fr);
    grid-template-areas: "name" "phone" "submit" "agree";
  }
  .name {
    grid-area: name;
  }
  .phone {
    grid-area: phone;
  }
  .submit {
    grid-area: submit;
    height: 60px;
    background-color: #a5d8ff;
    font-family: Montserrat;
    font-weight: 600;
    font-size: 20px;
    line-height: 1;
    &:disabled {
      background-color: #7b9ab1;
      cursor: not-allowed;
    }
  }

  .agree {
    grid-area: agree;
    color: white;
    max-width: 912px;
    line-height: 1.2;
    .link {
      color: #a5d8ff;
      text-decoration: none;
    }
  }
}
</style>
